import SelectField from "./widgets/select-field";
import SwitchField from "./widgets/switch-field";
import React, { useEffect, useState } from "react";
import { SearchFilterItem } from "../entry/server/movie";
import { AppContextType, WonmovContext } from "../context/app-context";
import { useContext } from "react";
import "@/styles/common-filter.css";

type CommonFilterProps = {
  allowType: boolean;
  allowGenre: boolean;
  allowSort: boolean;
  allowImdbRating: boolean;
  allowDubbed: boolean;
  allowSubtitled: boolean;

  typeDefaultValue?: string;
  genreDefaultValue?: string;
  sortDefaultValue?: string;
  imdbRatingDefaultValue?: string;
  dubbedDefaultValue?: boolean;
  subtitledDefaultValue?: boolean;

  onTypeChange?: (value: string) => void;
  onGenreChange?: (value: string) => void;
  onSortChange?: (value: string) => void;
  onImdbRatingChange?: (value: string) => void;
  onDubbedChange?: (value: boolean) => void;
  onSubtitledChange?: (value: boolean) => void;
}

const typeOptions = [
  { label: "نوع", value: "" },
  { label: "فیلم", value: "movie" },
  { label: "سریال", value: "series" },
  { label: "انیمیشن", value: "animation" },
  { label: "انیمه", value: "anime" },
];

const sortOptions = [
  { label: "مرتب سازی", value: "" },
  { label: "جدیدترین", value: "id" },
  { label: "به‌روزترین", value: "updated_at" },
  { label: "پر بازدیدترین", value: "views" },
  { label: "محبوب ترین", value: "popularity" },
  { label: "امتیاز Imdb", value: "imdb_rate" },
  { label: "سال انتشار", value: "year" },
];

const imdbRatingOptions = [
  { label: "امتیاز Imdb", value: "0" },
  { label: "بالاتر از 9.0", value: "9.0" },
  { label: "بالاتر از 8.0", value: "8.0" },
  { label: "بالاتر از 7.0", value: "7.0" },
  { label: "بالاتر از 6.0", value: "6.0" },
  { label: "بالاتر از 5.0", value: "5.0" },
]

export default function CommonFilter({
  allowType = true,
  allowGenre = true,
  allowSort = true,
  allowImdbRating = true,
  allowDubbed = true,
  allowSubtitled = true,
  typeDefaultValue = "",
  genreDefaultValue = "",
  sortDefaultValue = "",
  imdbRatingDefaultValue = "",
  dubbedDefaultValue = false, 
  subtitledDefaultValue = false,
  onTypeChange = () => {},
  onGenreChange = () => {},
  onSortChange = () => {},
  onImdbRatingChange = () => {},
  onDubbedChange = () => {},
  onSubtitledChange = () => {},
}: CommonFilterProps) {
  const { searchFilters } = useContext<AppContextType>(WonmovContext);
  const [isLoading, setIsLoading] = useState<boolean>(!searchFilters);
  const [genres, setGenres] = useState<SearchFilterItem[]>(searchFilters?.genres ?? []);

  useEffect(() => {
    if (searchFilters) {
      setGenres(searchFilters.genres);
      setIsLoading(false);
    }
  }, [searchFilters]);

  if (isLoading) {
    return (
      <section className="common-filter" dir="rtl">
        <div className="common-filter__panel">
          <div className="common-filter__loading shimmer" />
        </div>
      </section>
    );
  }

  return (
    <section className="common-filter" dir="rtl">
      <div className="common-filter__panel">
        <div className="common-filter__grid">
          <div className="common-filter__item">
            <SelectField uniqueKey="type" options={typeOptions} onChange={onTypeChange} value={typeDefaultValue ? typeDefaultValue : ""} disabled={!allowType} />
          </div>
          <div className="common-filter__item">
            <SelectField uniqueKey="genre" options={genres} onChange={onGenreChange} value={genreDefaultValue ? genreDefaultValue : ""} disabled={!allowGenre} />
          </div>
          <div className="common-filter__item">
            <SelectField uniqueKey="sort" options={sortOptions} onChange={onSortChange} value={sortDefaultValue ? sortDefaultValue : ""} disabled={!allowSort} />
          </div>
          <div className="common-filter__item">
            <SelectField uniqueKey="imdb-rating" options={imdbRatingOptions} onChange={onImdbRatingChange} value={imdbRatingDefaultValue ? imdbRatingDefaultValue : ""} disabled={!allowImdbRating} />
          </div>
          <div className="common-filter__item">
            <SwitchField label="دوبله فارسی" checked={dubbedDefaultValue ? dubbedDefaultValue : false} onChange={onDubbedChange} disabled={!allowDubbed} />
          </div>
          <div className="common-filter__item">
            <SwitchField label="زیرنویس فارسی" checked={subtitledDefaultValue ? subtitledDefaultValue : false} onChange={onSubtitledChange} disabled={!allowSubtitled} />
          </div>
        </div>
      </div>
    </section>
  );
}